import {
    IChangeStickyFooterDefaultStateAction,
    IUpdateInvoiceEnquiriesAction,
    IUpdateDrilldownEnquiriesAction,
    IStickyFooterInitStateAction
} from '../actions/sticky-footer-actions';
import { IBillingState } from '../state';

export const resetStickyFooterState =
    (state: IBillingState, action: IStickyFooterInitStateAction) => {
        return {
            ...state,
            stickyFooter: {
                enquiryEnabled: false,
                selectedItems: [],
                selectedProductsCount: 0
            }
        }
    };

export const changeStickyFooterSelectedItems =
    (state: IBillingState, action: IUpdateInvoiceEnquiriesAction) => {
        const selectedItems = [...state.stickyFooter.selectedItems];
        selectedItems[action.data.offerOrder] = action.data;

        const selectedProductsCount = selectedItems.reduce((acc, offer) => {
            if (offer) {
                acc += offer.selectedProducts.length;
                return acc;
            }
        }, 0)
        sessionStorage.setItem('TC:Billing:Enquiries', JSON.stringify(selectedItems));
        return {
            ...state,
            stickyFooter: {
                ...state.stickyFooter,
                selectedItems,
                selectedProductsCount
            }
        }
    };

export const changeStickyFooterSelectedItemsDrilldown =
    (state: IBillingState, action: IUpdateDrilldownEnquiriesAction) => {
        const selectedProductsCount = action.data;
        return {
            ...state,
            stickyFooter: {
                ...state.stickyFooter,
                selectedProductsCount
            }
        }
    };

export const changeStickyFooterDefaultState =
    (state: IBillingState, action: IChangeStickyFooterDefaultStateAction) => {
        if (!state.stickyFooter.enquiryEnabled) {
            sessionStorage.removeItem('TC:Billing:Enquiries');
        }
        return {
            ...state,
            stickyFooter: {
                ...state.stickyFooter,
                enquiryEnabled: !state.stickyFooter.enquiryEnabled
            }
        }
    };
